import React, { useEffect, useState, useRef } from "react";
import * as config from "../../config.js";
import styled from "styled-components";
import { colors } from "../../utils/colors";
import sendImage from "../../assets/img/arrow-circle-up.png";
import BouncingDots from "components/BouncingDots";
import { FormElement, FormLabel, FormInput } from "components/StyledElements";
import { getChatSession, sendChatMessage } from "services/agents";

const ChatWrapper = styled.div`
  min-height: 500px;
  height: 100%;
  margin-left: 10px;
  margin-right: 10px;
`;

const ChatInputWrapper = styled.div`
  height: 34px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 50px;
  border: 1px solid #e5e5e5;
  background-color: #f5f5f5;
  outline: none;
`;

const ChatInput = styled.textarea`
  color: black;
  height: 20px;
  width: 100%;
  padding-left: 10px;
  padding-right: 45px;
  justify-content: flex-start;
  align-items: center;
  font-size: 16px;
  resize: none;
  border: none;
  background: none;
  outline: none;
  padding-top: 0px;
  padding-bottom: 0px;

  &:focus {
    outline: none;
    box-shadow: none;
  }
`;

const SendIcon = styled.div`
  position: absolute;
  right: 28px;
  bottom: 16px;
  width: 26px;
  height: 26px;
  background: transparent url(${sendImage}) no-repeat center center;
  background-size: 26px 26px;
  cursor: pointer;
`;

const ChatBubbleWrapper = styled.div`
  width: 100%;
`;

const UserChatBubble = styled.div`
  max-width: 70%;
  display: inline-block;
  margin-bottom: 20px;
  background-color: var(--chat-bubble-bg);
  padding-top: 5px;
  padding-right: 10px;
  padding-bottom: 5px;
  padding-left: 10px;
  border-radius: 20px;
  align-self: flex-end;
  color: var(--chat-bubble-font-color);
  font-size: 14px;
  text-align: left;
`;

const AgentChatBubble = styled.div`
  max-width: 70%;
  display: inline-block;
  margin-bottom: 20px;
  background-color: var(--chat-bubble-bg); 
  padding-top: 5px;
  padding-right: 10px;
  padding-bottom: 5px;
  padding-left: 10px;
  border-radius: 20px;
  align-self: flex-start;
  color: var(--chat-bubble-font-color);
  font-size: 14px;
  text-align: left;
`;

const AgentThinking = styled.div`
    height: 42px;
    width: 100px;
    min-height: 42px;
    margin-bottom: 20px;
    background-color: #b8bcf7;
    color: ${colors().darkestAbyss};s
    border-radius: 20px;  
    align-self: flex-start;
    align-items: center;
    justify-content: center;
    display: flex;  
    border-radius: 20px;
    & > div {
        margin-top: 7px;
    }
`;

const ChatSession = ({ agent = null, chat_session_id = null, style = {} }) => {
  const [sending, setSending] = useState(false);
  const [chatSession, setChatSession] = useState();
  const [quizzes, setQuizzes] = useState({});
  const [activeQuiz, setActiveQuiz] = useState(null);
  const [message, setMessage] = useState("");
  const [messageBubbles, setMessageBubbles] = useState([]);
  const chatWrapperRef = useRef(null);
  const activeQuestion = useRef(0);
  const correctAnswers = useRef(0);
  //const [sending, setSending] = useState(false);

  useEffect(() => {
    const fetchChatSession = async () => {
      if (chat_session_id) {
        const fetchedChatSession = await getChatSession(chat_session_id);
        setChatSession(fetchedChatSession);
        console.log("!!! FETCHED CHAT SESSION: ", fetchedChatSession);
      }
    }

    if (chat_session_id) {
      fetchChatSession();
    } else {
      setChatSession(null);
      setMessageBubbles([]);
    }
  }, [chat_session_id]);

  useEffect(() => {
    if (chatSession && chatSession.messages) {
      setMessageBubbles(
        chatSession.messages.map((message, i) => {
          return (
            <ChatBubble key={i} type={message.message_type} message={message.message} />
          );
        })
      );
    }
  }, [chatSession]);

  useEffect(() => {
    console.log("CHAT WRAPPER REF: ", chatWrapperRef.current);
    if (chatWrapperRef.current) {
      chatWrapperRef.current.scrollTop = chatWrapperRef.current.scrollHeight;
    }
  }, [messageBubbles]);

  if (!agent) {
    return <div>No agent defined</div>;
  }

  const sendMessage = async () => {
    setSending(true);
    if (activeQuiz) {
      setMessage("");
      if (message.toLocaleLowerCase() === "exit") {
        setActiveQuiz(null);
        activeQuestion.current = 0;
        const a = (
          <ChatBubbleWrapper style={{ textAlign: "left" }}>
            <AgentChatBubble>Exited Quiz Mode</AgentChatBubble>
          </ChatBubbleWrapper>
        );
        setMessageBubbles([...messageBubbles, a]);
        return;
      }

      const m = (
        <ChatBubbleWrapper style={{ textAlign: "right" }}>
          <div>CLOSE</div>
          <UserChatBubble>{message.replace(/\n/, "<br>")}</UserChatBubble>
        </ChatBubbleWrapper>
      );
      let a = <></>;
      const answer = parseInt(message);
      if (isNaN(answer)) {
        a = (
          <ChatBubbleWrapper style={{ textAlign: "left" }}>
            <AgentChatBubble>Invalid Answer.</AgentChatBubble>
          </ChatBubbleWrapper>
        );
        setMessageBubbles([...messageBubbles, m, a]);
      } else {
        const question = quizzes[activeQuiz].questions[activeQuestion.current];
        console.log("QUESTION: ", question);
        console.log(
          "ANSWER: ",
          question.question.correct_answer_index + 1,
          answer
        );
        if (question.question.correct_answer_index + 1 === answer) {
          correctAnswers.current += 1;
          a = (
            <ChatBubbleWrapper style={{ textAlign: "left" }}>
              <AgentChatBubble>Correct Answer.</AgentChatBubble>
            </ChatBubbleWrapper>
          );
          setMessageBubbles([...messageBubbles, m, a]);
        } else {
          a = (
            <ChatBubbleWrapper style={{ textAlign: "left" }}>
              <AgentChatBubble>
                Sorry, that answer is incorrect. The correct answer is{" "}
                <b>
                  {question.question.correct_answer_index + 1}.{" "}
                  {question.question.correct_answer}
                </b>
              </AgentChatBubble>
            </ChatBubbleWrapper>
          );
          setMessageBubbles([...messageBubbles, m, a]);
        }
        let explanation = <></>;

        if (question.source === "media") {
          let image = question.image_url ? (
            <img
              alt={question.media_name}
              style={{ height: "90px", width: "90px" }}
              src={question.image_url}
            />
          ) : (
            <></>
          );
          explanation = (
            <ChatBubbleWrapper style={{ textAlign: "left" }}>
              <AgentChatBubble>
                The answer to the question can be found in the following
                article.{" "}
                <a
                  style={{
                    marginLeft: "5px",
                    fontWeight: 600,
                    display: "flex",
                    flexDirection: "row",
                  }}
                  target="_blank"
                  rel="noreferrer"
                  href={question.media_url}
                >
                  {image}
                  <span style={{ marginLeft: "5px" }}>
                    {question.media_name}
                  </span>
                </a>
                <div style={{ fontStyle: "italic" }}>
                  {question.source_text}
                </div>
              </AgentChatBubble>
            </ChatBubbleWrapper>
          );
        } else {
          explanation = (
            <ChatBubbleWrapper style={{ textAlign: "left" }}>
              <AgentChatBubble>
                The answer to the question can be found in the following section
                of the article.{" "}
                <div style={{ fontStyle: "italic" }}>
                  {question.source_text}
                </div>
              </AgentChatBubble>
            </ChatBubbleWrapper>
          );
        }

        let finalMessage = <></>;
        if (
          activeQuestion.current + 1 ===
          quizzes[activeQuiz].questions.length
        ) {
          setActiveQuiz(null);
          activeQuestion.current = 0;
          const quiz = quizzes[activeQuiz];
          finalMessage = (
            <ChatBubbleWrapper style={{ textAlign: "left" }}>
              <AgentChatBubble>
                Quiz Complete. You got {correctAnswers.current} out of{" "}
                {quiz.questions.length} questions correct.
              </AgentChatBubble>
            </ChatBubbleWrapper>
          );
        } else {
          activeQuestion.current++;
          finalMessage = (
            <ChatBubbleWrapper style={{ textAlign: "left" }}>
              <AgentChatBubble>
                {renderQuizQuestion(activeQuiz)}
              </AgentChatBubble>
            </ChatBubbleWrapper>
          );
        }

        setMessageBubbles([...messageBubbles, m, a, explanation, finalMessage]);
      }
      //dispatch(sendQuizMessage(activeQuiz, activeQuestion, message, chatSession.public_id));
      return;
    }
    setMessage("");
    // Update chatSession messages
    const updatedChatSession = { ...chatSession };
    if (!updatedChatSession.messages) updatedChatSession.messages = [];
    updatedChatSession.messages = [...updatedChatSession.messages, { message: message, message_type: "user" }];
    setChatSession(updatedChatSession);
    const chatResponse = await sendChatMessage(message, chatSession.public_id, false, true);
    const agentMessage = chatResponse.agent_message;
    const contextUpdate = chatResponse.context;
    const updatedChatSession2 = { ...updatedChatSession };
    updatedChatSession2.context = contextUpdate;
    updatedChatSession2.messages = [...updatedChatSession2.messages, agentMessage];
    setChatSession(updatedChatSession2);
    setSending(false);



  };

  const articleList = (articles) => {
    const list = [];
    articles.forEach((m, i) => {
      let image = <></>;
      try {
        const additionalData = JSON.parse(m.additional_data);
        if (additionalData.image_url) {
          image = (
            <img
              src={additionalData.image_url}
              alt={m.name}
              style={{ width: "85px" }}
            />
          );
        }
      } catch (ex) { }

      list.push(
        <li
          style={{
            display: "flex",
            flexDirection: "row",
            marginBottom: "10px",
          }}
        >
          {i + 1}.{" "}
          <a
            style={{
              marginLeft: "5px",
              display: "flex",
              flexDirection: "row",
            }}
            target="_blank"
            rel="noreferrer"
            href={m.fullpath}
          >
            {image}
            <span style={{ marginLeft: "5px" }}>{m.name}</span>
          </a>
        </li>
      );
    });
    return <ul>{list}</ul>;
  };

  const renderQuizQuestion = (_quiz = null) => {
    const quiz = quizzes[activeQuiz]
      ? quizzes[activeQuiz]
      : _quiz
        ? _quiz
        : null;
    if (!quiz) {
      return <>Quiz Not Ready</>;
    }

    const question = quiz.questions[activeQuestion.current].question;
    const answers = question.answers.map((answer, i) => {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginBottom: "10px",
          }}
        >
          <span style={{ marginLeft: "5px" }}>
            {i + 1}. {answer}
          </span>
        </div>
      );
    });
    return (
      <div style={{ paddingBottom: "20px", paddingTop: "20px" }}>
        <div>
          Question {activeQuestion.current + 1} of {quiz.questions.length}
        </div>
        <div style={{ fontWeight: 600, marginBottom: "5px" }}>
          {question.text}
        </div>
        {answers}
      </div>
    );
  };

  const ChatBubble = ({ type = "", message = "" }) => {
    if (!message) {
      return;
    }

    let source = <></>;
    let response = [
      <div key="0">
        {message.split("\n").map((m, i) => (
          <p key={i} style={{ color: "var(--chat-bubble-font-color)" }}>{m}</p>
        ))}
      </div>
    ];

    try {
      console.log("!!! MESSAGE: ", message);
      const jsonData = JSON.parse(message.trim());
      console.log("!!! JSON DATA: ", jsonData);
      if (jsonData) {
        if (jsonData.response_type === "similar_articles") {
          response = [
            <p>
              Here's a list of articles similar to "{jsonData.likely_doc.name}"
            </p>,
          ];
          response.push(articleList(jsonData.related_media));
        } else if (jsonData.response_type === "article_list") {
          response = [<p>Here's a list of articles</p>];
          response.push(articleList(jsonData.media));
        } else if (jsonData.response_type === "quiz") {
          const _quizzes = { ...quizzes };
          const quizID = Math.floor(Math.random() * 999999999999);
          _quizzes[quizID] = {
            questions: jsonData.questions,
            selectedAnswers: [],
          };
          setQuizzes(_quizzes);
          setActiveQuiz(quizID);

          const intro = [
            <p>
              Here's a quiz generated from the content specified. If you would
              like to end the quiz before you complete it, type 'exit'.
            </p>,
          ];
          response = [renderQuizQuestion(_quizzes[quizID])];
          return (
            <>
              <ChatBubbleWrapper>
                <AgentChatBubble>{intro}</AgentChatBubble>
              </ChatBubbleWrapper>
              ``
              <ChatBubbleWrapper>
                <AgentChatBubble>{response}</AgentChatBubble>
              </ChatBubbleWrapper>
            </>
          );
        } else if (jsonData.response || jsonData.text) {
          const text = jsonData.response ? jsonData.response : jsonData.text;
          response = [
            <div key="1">
              {text.split("\n").map((m, i) => (
                <p key={i}>{m}</p>
              ))}
            </div>,
          ];
          if (
            jsonData.source &&
            jsonData.source !== "None" &&
            jsonData.media_id &&
            jsonData.media_id !== "None"
          ) {
            if (jsonData.media_type === "video") {
              source = (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#000000",
                    borderTop: "1px solid #121212",
                  }}
                >
                  <div style={{ width: "400px" }}>
                    <video
                      preload="auto"
                      style={{ width: "400px" }}
                      src={`${config.REST_SERVER_URL}/video/${jsonData.source_media_id ?? jsonData.media_id
                        }/video.mp4`}
                      controls
                      onLoadedMetadata={(e) => {
                        console.log("LOADED VIDEO: ", jsonData.start_time);
                        e.target.currentTime = jsonData.start_time;
                      }}
                    ></video>
                    <a
                      rel="noreferrer"
                      target="_blank"
                      style={{ fontWeight: 500 }}
                      href={jsonData.url}
                    >
                      Original Video: {jsonData.source}
                    </a>
                  </div>
                </div>
              );
              response.push(source);
            } else {
              source = (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#000000",
                    borderTop: "1px solid #121212",
                  }}
                >
                  <div style={{ width: "400px" }}>
                    <a
                      rel="noreferrer"
                      target="_blank"
                      style={{ fontWeight: 500 }}
                      href={jsonData.url}
                    >
                      {jsonData.source}
                      <img
                        style={{ maxWidth: "400px" }}
                        src={jsonData.image_url}
                        alt={jsonData.source}
                      ></img>
                    </a>
                  </div>
                </div>
              );
              response.push(source);
            }
          }
        }
      }
    } catch (ex) { }
    console.log("CHAT BUBBLE: ", type, message);
    if (type === "user") {
      return (
        <ChatBubbleWrapper style={{ textAlign: "right" }}>
          <UserChatBubble>{message.replace(/\n/, "<br>")}</UserChatBubble>
        </ChatBubbleWrapper>
      );
    } else if (type === "agent") {
      console.log("!!! RESPONSE: ", response);
      return (
        <ChatBubbleWrapper>
          <AgentChatBubble>{response}</AgentChatBubble>
        </ChatBubbleWrapper>
      );
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      if (!e.shiftKey) {
        e.preventDefault();
        sendMessage();
      } else {
        setMessage(message + "\n");
      }
    }
  };

  return (
    <div style={{ ...style }}>
      {/*header*/}
      <FormElement>
        <FormLabel label="Context" />
        <FormInput
          as="textarea"
          disabled
          style={{ height: "80px", resize: "vertical" }}
          value={chatSession ? typeof chatSession.context === "string" ? chatSession.context : JSON.stringify(chatSession.context) : ""}
        />
      </FormElement>
      <div className="relative pl-10 flex-auto">
        <div
          ref={chatWrapperRef}
          className="my-4 text-blueGray-500 text-lg leading-relaxed overflow-auto flex"
          style={{ height: "70vh" }}
        >
          <ChatWrapper>
            {messageBubbles}
            {sending ? (
              <AgentThinking>
                <BouncingDots />
              </AgentThinking>
            ) : null}
          </ChatWrapper>
        </div>
      </div>
      {/*footer*/}
      <div
        className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b"
        style={{ height: "60px" }}
      >
        <ChatInputWrapper>
          <ChatInput
            type="textarea"
            value={message}
            onKeyPress={handleKeyPress}
            onChange={(e) => setMessage(e.target.value)}
          ></ChatInput>
          <SendIcon
            style={{ display: message.length > 0 ? "block" : "none" }}
            onClick={sendMessage}
          />
        </ChatInputWrapper>
      </div>
    </div>
  );
};

export default ChatSession;
